<template>
	<div>
		<loading v-if="!loaded" />
		<el-tabs v-model="tabName" v-if="loaded">
			<el-tab-pane label="អតិថិជនទាំងអស់" name="first"></el-tab-pane>
		</el-tabs>
		<div v-if="tabName == 'first' && loaded">
			<div class="md-layout">
				<div class="md-layout-item md-small-size-100 md-size-25">
					<md-field>
						<label>ស្វែងរកតាមរយៈ ឈ្មោះ លេខទូរស័ព្ទ ឬ លេខកូដ</label>
						<md-input v-model="search.text" type="text" @keyup.enter="searchHandler()"></md-input>
					</md-field>
				</div>
				<div class="md-layout-item md-small-size-100 md-size-25">
					<md-field>
						<label>ស្ថានភាពគណនី</label>
						<md-select placeholder="ស្ថានភាពគណនី (ទាំងអស់)" v-model="search.status">
							<md-option value="">ទាំងអស់</md-option>
							<md-option value="1">ដំណើរការ</md-option>
							<md-option value="0">មិនដំណើរការ</md-option>
						</md-select>
					</md-field>
				</div>
				<div class="md-layout-item md-small-size-100 md-size-25">
					<md-field>
						<label>ផ្ទៀងផ្ទាត់</label>
						<md-select placeholder="ផ្ទៀងផ្ទាត់ (ទាំងអស់)" v-model="search.verified">
							<md-option value="">ទាំងអស់</md-option>
							<md-option value="1">បានផ្ទៀងផ្ទាត់</md-option>
							<md-option value="0">មិនបានផ្ទៀងផ្ទាត់</md-option>
						</md-select>
					</md-field>
				</div>
				<div class="md-layout-item md-size-25">
					<md-button class="md-raised md-primary" @click="searchHandler()" style="width: 100%">ស្វែងរក</md-button>
				</div>
			</div>

			<md-table v-if="clientList.length > 0">
				<md-table-row>
					<md-table-head>ល.រ</md-table-head>
					<md-table-head>គណនី</md-table-head>
					<md-table-head>ព័ត៌មាន</md-table-head>
					<md-table-head>សមតុល្យទឹកប្រាក់</md-table-head>
					<md-table-head>ថ្ងៃចូលប្រព័ន្ធចុងក្រោយ</md-table-head>
					<md-table-head>ថ្ងៃបង្កើត</md-table-head>
					<md-table-head>ស្ថានភាព</md-table-head>
					<md-table-head>សកម្មភាព</md-table-head>
				</md-table-row>

				<md-table-row v-for="(client, index) in clientList">
					<md-table-cell>{{ index + 1 }}</md-table-cell>
					<md-table-cell><b>{{client.username}} <md-icon class="verify" v-if="client.verified == 1">verified</md-icon></b><br>m-{{ config.orderlify(client.id) }}</md-table-cell>
					<md-table-cell><b>{{ client.name }}</b><br>{{ client.phone }}</md-table-cell>
					<md-table-cell><b>{{ config.moneylify(client.balance) }}</b></md-table-cell>
					<md-table-cell><b>IP : {{ client.last_login_ip || "មិនទាន់មាន" }}</b><br><b>{{ config.datelify(client.last_login) }}</b> ({{config.timelify(client.last_login)}})</md-table-cell>
					<md-table-cell><b>{{ config.datelify(client.created_date) }}</b><br>{{config.timelify(client.created_date)}}</md-table-cell>
					<md-table-cell>
						<span class="green" v-if="client.status == 1">{{ config.getStatus(client.status) }}</span>
						<span class="error" v-if="client.status == 0">{{ config.getStatus(client.status) }}</span>
					</md-table-cell>
					<md-table-cell>

						<router-link :to="'/clients/detail/' + client.hash">
							<md-button class="md-just-icon md-simple md-success">
								<md-icon>visibility</md-icon>
								<md-tooltip md-direction="top">បង្ហាញបន្ថែម</md-tooltip>
							</md-button>
						</router-link>
						<router-link :to="'/clients/bet_provider_detail/' + client.hash">
							<md-button class="md-just-icon md-simple md-primary">
								<md-icon>currency_exchange</md-icon>
								<md-tooltip md-direction="top">ប្រវត្តិភ្នាល់</md-tooltip>
							</md-button>
						</router-link>
						<!-- <router-link :to="'/clients/edit/' + client.hash">

						</router-link> -->

						<md-button class="md-just-icon md-simple md-danger" v-if="client.status == 1" @click="deactivate(client.hash)">
							<md-icon>stop_circle</md-icon>
							<md-tooltip md-direction="top">ផ្អាកដំណើរការ</md-tooltip>
						</md-button>
						<md-button class="md-just-icon md-simple md-success" v-if="client.status == 0" @click="activate(client.hash)">
							<md-icon>play_circle</md-icon>
							<md-tooltip md-direction="top">ដាក់ដំណើរការ</md-tooltip>
						</md-button>

					</md-table-cell>
				</md-table-row>
			</md-table>

			<h4 class="text-center" v-if="clientList.length == 0 && loadMore == true">មិនមានអតិថិជន</h4>
			<div class="places-buttons text-center" v-if="loadMore">
				<md-button class="md-primary" @click="searchHandler(true)">បង្ហាញបន្ថែម</md-button>
			</div>
		</div>

	<!-- <md-dialog-confirm :md-active.sync="deleteDialogActive" md-title="តើអ្នកពិតជាចង់លុបក្រុមហ៊ុននេះពិតមែនទេ ?"
			md-content="ព័ត៌មានក្រុមហ៊ុននឹងត្រូវបានលុបចេញពីបញ្ជីជារាងរហូត។" md-confirm-text="លុប" md-cancel-text="បោះបង់"
			@md-cancel="onCancel" @md-confirm="onDelete" /> -->
	</div>

</template>

<script>
	import { Datetime } from 'vue-datetime';
	export default {
		components: { Datetime },
		created() {
			this.searchHandler();
			// this.getReferral();
		},

		data() {
			return {
				tabName: "first",
				loaded: false,
				deleteDialogActive: false,
				deleteSelected: '',
				search: {
					text: "",
					status: "",
					verified: ""
				},
				client: {
					name: "",
					phone: "",
					description: "",
					referral_id: "",
					referralArray: ""
				},
				loadMore: true,
				clientList: [],
				referralList: []

			}
		},
		methods: {
			postClient() {
				if (!this.checkValidation()) return false;
				this.$http.post(this.config.api + "/admin/client/post", {
					client: this.client
				}).then(data => {
					if (data.body.status == 'success') {
						this.tabName = 'first'
						this.$notification.notify({
							message: "អ្នកផ្ញើរឥវ៉ាន់ត្រូវបានបង្កើតដោយជោគជ័យ។",
							icon: 'done',
							type: 'success'
						});
						this.clearAll();
						this.searchHandler();

					}
				})
			},
			searchHandler(more = false) {
				this.$http.post(this.config.api + "/admin/user/search", {
					text: this.search.text,
					status: this.search.status,
					verified: this.search.verified,
					offset: more ? this.clientList.length : 0
				}).then(data => {
					if (data.body.data.length == 100) this.loadMore = true;
					else this.loadMore = false;
					this.clientList = more ? this.clientList.concat(data.body.data) : data.body.data;
					this.loaded = true;
				})
			},
			deactivate(hash) {
				this.$http.post(this.config.api + "/admin/user/deactivate", {
					hash_id: hash
				}).then(data => {
					if (data.body.status == 'success') {
						this.tabName = 'first'
						this.$notification.notify({message: "ជោគជ័យ។",icon: 'done',type: 'success'});
						this.searchHandler();
					}
				})
			},
			activate(hash) {
				this.$http.post(this.config.api + "/admin/user/activate", {
					hash_id: hash
				}).then(data => {
					if (data.body.status == 'success') {
						this.tabName = 'first'
						this.$notification.notify({message: "ជោគជ័យ។",icon: 'done',type: 'success'});
						this.searchHandler();
					}
				})
			},
			checkValidation() {
				if (String(this.client.name).length > 0 && String(this.name_khmer).length > 0 && String(this.client.phone).length > 0) {
					return true;
				} else {
					this.$notification.notify({
						message: "សូមបញ្ចូលព័ត៌មាន។",
						icon: 'info',
						type: 'warning'
					});
					return false;
				}
			},
			clearAll() {
				this.search = {
					text: "",
					status: "",
					verified: ""
				}
				this.client = {
					name: "",
					phone: "",
					description: ""
				}
			}
		}
	}
</script>
<style scoped>
	.product-thumbnail {
		width: 64px;
		height: 64px;
	}

	.grid-8 {
		text-align: center;
		max-width: 20%;
		min-width: 20%;
		flex: 0 0 20%;
	}

	.thumb-product {
		width: 50%;
	}
</style>



// WEBPACK FOOTER //
// src/pages/Clients/View.vue